import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Header from '@layout/HeaderTemplates/Base';
import K12Container from '@cont/K12/k12';
import Footer from '@layout/Footer/BaseFooter/Footer';
import { breakpoints } from '@styles/index';
import getK12Info from '@cms/api';

const StyledFooter = styled(Footer)`
  margin-top: 0;
  @media (max-width: ${breakpoints.tablet}) {
    & > div {
      width: 728px;
      justify-content: space-between;
    }
  }
  @media (max-width: ${breakpoints.mobile}) {
    & > div {
      width: 100%;
    }
  }
`;

function K12({ apiResponse }) {
  const [showLeadgen, setShowLeadGen] = React.useState(false);
  return (
    <>
      <Header />
      <K12Container
        showLeadgen={showLeadgen}
        setShowLeadGen={setShowLeadGen}
        apiResponse={JSON.parse(apiResponse)}
      />
      <StyledFooter display />
    </>
  );
}

const Layout = ({ children }) => <>{children}</>;
K12.Layout = Layout;

K12.propTypes = {
  apiResponse: PropTypes.string.isRequired
};
K12.getInitialProps = async () => {
  const response = await getK12Info('api/k12-info/cbse-class-6-12/');
  return { apiResponse: JSON.stringify(response) };
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default K12;
